import * as React from 'react';

import { Divider } from 'antd';
import { Button, ButtonType } from 'farmhub-ui-core';
import { useHistory } from 'react-router-dom';

import { PageTitleBar } from 'components';
import { AddOutlineIcon } from 'components/Icon';
import { ConnectOutlineIcon } from 'components/Icon/Menu';
import MainContent from 'components/Layout/MainContent';
import { theme } from 'styled';

import EntityStockReportTable from './EntityStockReportTable';

export const EntityStockReportPage = (): JSX.Element => {
  const history = useHistory();

  const ExtraAction = (
    <>
      <Button
        height={theme.button.height.sm}
        icon={{
          children: (
            <ConnectOutlineIcon
              color={theme.colors.text.secondary}
              height={18}
              width={18}
            />
          ),
        }}
        type={ButtonType.Text}
        onClick={() => history.push('/settings/stock-report/connect/list')}
      >
        Kết nối
      </Button>
      <Divider type="vertical" />
      <Button
        height={theme.button.height.sm}
        icon={{ children: <AddOutlineIcon height={16} width={16} /> }}
        type={ButtonType.Text}
        onClick={() => history.push(`/settings/stock-report/create`)}
      >
        Thêm mới
      </Button>
    </>
  );

  return (
    <MainContent>
      <PageTitleBar extraAction={ExtraAction} title="Báo cáo tồn kho" />
      <EntityStockReportTable />
    </MainContent>
  );
};
